<template>
  <v-dialog v-model="dialog" width="1331">
    <v-card class="ma-0 pa-0">
      <v-card-title
        class="justify-center align-center color-white back-556C96 d-flex pa-0 ma-0"
        style="height:44px;"
      >
        <h3>발주계획 대비 집행 수량</h3>
        <v-icon
          class="color-white"
          style="position: absolute; right: 15px;"
          @click="dialog = !dialog"
          >mdi-close</v-icon
        >
      </v-card-title>
      <v-card-text class="mt-5 ma-0 pa-0 back-white">
        <v-row class="ma-0 pa-0 mb-4" style="margin-left:21px !important;">
          <div style="width:160px;">
            <v-select
              v-model="status"
              outlined
              dense
              hide-details
              :items="statusList"
              width="160"
              height="41"
            ></v-select>
          </div>
          <v-spacer />
          <div class="small-text">
            <span>단위 : ton</span>
          </div>
        </v-row>
        <v-row class="ma-0 pa-0" style="margin-left:21px !important">
          <v-simple-table width="1264">
            <thead style="height:81px;" class="">
              <th
                style="width:88px !important;min-width:0px;"
                class="border-right-556C96  border-top-556C96 border-bottom-556C96 total-text "
              >
                총계
              </th>
              <th style="width:1049px;" class=" border-top-556C96  ">
                <v-progress-linear
                  :value="
                    (Math.ceil((sum(lists) / sum(constList)) * 10) / 10) * 100 +
                      5
                  "
                  color="#718AB8"
                  height="35"
                  style="width:1032px;"
                  width="1032"
                >
                  <template>
                    <div
                      class="justify-content"
                      :style="
                        'width:' +
                          (5 +
                            (Math.ceil((sum(lists) / sum(constList)) * 10) /
                              10) *
                              100) +
                          '%'
                      "
                    >
                      <strong
                        >{{
                          Math.ceil((sum(lists) / sum(constList)) * 1000) / 10
                        }}%</strong
                      >
                    </div>
                  </template>
                </v-progress-linear>
                <div class="triangle"></div>
              </th>
              <th
                class=" border-top-556C96 border-bottom-556C96 border-left-556C96"
                style="height:81px;width:126px;"
              >
                <v-row class="ma-0 pa-0  justify-center align-center d-flex">
                  <h1 class="color-2B4065">{{ sum(lists) }}</h1>
                  <h1 class="color-2B4065 ml-2 mr-2">/</h1>
                  <h1 class="color-9C9C9C">{{ sum(constList) }}</h1>
                </v-row>
              </th>
            </thead>
            <tbody>
              <tr v-for="(item, i) in listItem" :key="i" style="height:55px;">
                <td
                  class="border-right-556C96 content-text"
                  style="width:88px !important; min-width:0px;"
                  :class="
                    listItem.length - 1 == i ? 'border-bottom-556C96' : ''
                  "
                >
                  {{ item }}
                </td>
                <td
                  :class="
                    listItem.length - 1 == i ? 'border-bottom-556C96' : ''
                  "
                  class="ma-0 pa-0 justify-start align-start"
                >
                  <v-progress-linear
                    style="margin-top:-7px; width:1032px;"
                    :value="
                      lists[i]
                        ? mathRound(lists[i] / constList[i]) * 100 + 5
                        : '5'
                    "
                    color="#A8B7D1"
                    height="35"
                  >
                    <template>
                      <div
                        class="justify-content text-center"
                        :style="
                          'width:' +
                            (lists[i]
                              ? mathRound(lists[i] / constList[i]) * 100 + 5
                              : '5') +
                            '%'
                        "
                      >
                        <strong>{{
                          lists[i]
                            ? constList[i]
                              ? Math.round((lists[i] / constList[i]) * 1000) /
                                  10 +
                                "%"
                              : "등록"
                            : "0%"
                        }}</strong>
                      </div>
                    </template>
                  </v-progress-linear>
                  <div class="triangle"></div>
                </td>
                <td
                  class="justify-center align-center d-flex border-left-556C96 "
                  v-if="constList[i] || lists[i]"
                  style="height:55px;"
                  :class="
                    listItem.length - 1 == i
                      ? 'border-bottom-556C96'
                      : 'border-bottom-B3B3B3'
                  "
                >
                  <v-row class="ma-0 pa-0 justify-center align-center d-flex">
                    <h2 class="color-2B4065">
                      {{ mathRound(lists[i]) }}
                    </h2>
                    <h2 class="color-2B4065 ml-2 mr-2">/</h2>
                    <h2 class="color-9C9C9C">
                      {{ mathRound(constList[i]) }}
                    </h2>
                  </v-row>
                </td>
                <td
                  class="justify-center align-center d-flex border-left-556C96"
                  :class="
                    listItem.length - 1 == i
                      ? 'border-bottom-556C96'
                      : 'border-bottom-B3B3B3'
                  "
                  v-else
                  style="height:55px;"
                >
                  <div class="justify-center align-center d-flex ma-0 pa-0">
                    -
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
        <v-card-actions
          class="justify-center align-center"
          style="padding-top:20px;padding-bottom:21px;"
        >
          <v-btn
            color="#5b9bd5"
            class="color-white"
            @click="dialog = !dialog"
            rounded
            width="140"
            height="38"
            >확인</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Commonality from "@/mixin/Commonality";
import ConstApi from "@/api/ConstructionService";
import OrderApi from "@/api/OrderService";
import InvoiceApi from "@/api/InvoiceService";

import CompleteApi from "@/api/CompleteService";

import OrderInvoiceApi from "@/api/OrderInvoiceService";

export default {
  mixins: [Commonality],
  data: () => ({
    dialog: false,
    statusList: ["발주수량", "출고수량", "입고수량"],
    selected: "",
    status: "발주수량",
    //listItem:['10mm','13mm','16mm','19mm','22mm','25mm','29mm','32mm'],
    lists: [],
    constList: [],
    orderInvoiceTotalList: [],
    totalSumList: [],
    orderList: [],
    invoiceList: [],
    completeList: [],
  }),
  computed: {
    listItem() {
      let tempList = [];
      for (let i = 0; i < this.materialList.length; i++) {
        tempList.push(this.materialList[i].rebar_name + "mm");
      }
      return tempList;
    },
  },
  watch: {
    status(val) {
      if (val == "발주수량") {
        this.lists = this.orderList;
      } else if (val == "출고수량") {
        this.lists = this.invoiceList;
      } else if (val == "입고수량") {
        this.lists = this.completeList;
      }
    },
  },
  async created() {
    this.$bus.$on("resultOpen", () => {
      this.dialog = true;
    });
    this.init();
  },
  methods: {
    async init() {
      let data = { constructionId: this.constructionId };
      let resData = await ConstApi.constructionTotalList(data);
      this.constList = resData.data.constList[0].rebarQty;
      let res = await OrderInvoiceApi.achievementList(data);
      this.completeList = res.data.orderInvoiceTotalList.totalComplete[0];
      this.invoiceList = res.data.orderInvoiceTotalList.totalInvoice[0];
      this.orderList = res.data.orderInvoiceTotalList.totalOrder[0];
      this.lists = this.orderList;
    },
  },
};
</script>

<style>
.v-progress-linear__content {
  justify-content: start;
}
.v-progress-linear__determinate::v-deep {
  border-radius: 0 20px 20px 0 !important;
}
.v-progress-linear__determinate {
  border-radius: 0 20px 20px 0 !important;
}
.v-progress-linear {
  background: #f0f0f0;
}
.v-progress-linear__background {
  opacity: 0 !important;
}
</style>
<style scoped>
.small-text {
  margin-right: 86px;
  padding-top: 18px;
}
span {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #aeaeae;
}
h3 {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #ffffff;
}
.content-text {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  color: #556c96;
}
.total-text {
  color: #556c96;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 22px;
}
strong {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 19px;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: 0;
}
h1 {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 19px;
}
h2 {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 19px;
}
.triangle {
  transform: rotate(180deg);
  width: 0px;
  height: 0px;
  border-bottom: 12px solid #838d9e;
  border-right: 16px solid transparent;
  border-left: 0px solid transparent;
}
b,
strong {
  color: #ffffff;
}
.v-progress-linear {
  border-radius: 0 20px 20px 0 !important;
}

.border-top-556C96 {
  border-top: 1px solid #556c96 !important;
}
.border-bottom-556C96 {
  border-bottom: 1px solid #556c96 !important;
}
.border-left-556C96 {
  border-left: 1px solid #556c96;
}
.border-right-556C96 {
  border-right: 1px solid #556c96;
}
.border-bottom-B3B3B3 {
  border-bottom: thin solid #b3b3b3 !important;
}
.color-2B4065 {
  color: #2b4065;
}
.color-9C9C9C {
  color: #9c9c9c;
}
.divider {
  border: thin solid;
  transform: rotate(110deg);
  width: 30px;
  color: #2b4065;
}
</style>
